const sources = [
  { text: "Start using Verbatim for free", flag: "gb" },
  { text: "Starte jetzt kostenlos mit Verbatim", flag: "at" },
  { text: "Zacznij korzystać z Verbatim za darmo", flag: "pl" },
  { text: "Begin gratis met Verbatim", flag: "nl" },
  { text: "Commencez à utiliser Verbatim gratuitement", flag: "fr" },
  { text: "Empieza a usar Verbatim gratis", flag: "es" },
  { text: "Verbatim'i ücretsiz kullanmaya başla", flag: "tr" },
  { text: "Comece a usar o Verbatim grátis", flag: "pt" },
];

const MarqueeItem = ({ s, index }) => (
  <div
    data-testid={`cta-source-${index}`}
    className="font-display text-3xl sm:text-4xl font-bold text-white/30 hover:text-white transition-colors flex items-center gap-3 italic"
  >
    <img
      src={`https://flagcdn.com/${s.flag}.svg`}
      alt={`${s.flag} flag`}
      className="w-7 h-[15px] object-cover rounded-[1px] shrink-0"
    />
    <span>{s.text}</span>
  </div>
);

export const LanguageCTAMarquee = () => {
  return (
    <section
      data-testid="cta-marquee-section"
      className="relative border-y border-white/5 py-6 overflow-hidden"
    >
      <div className="relative">
        <div className="scroll-marquee whitespace-nowrap will-change-transform">
          <div>
            {sources.map((s, i) => (
              <MarqueeItem key={`a-${i}`} s={s} index={i} />
            ))}
          </div>
          <div>
            {sources.map((s, i) => (
              <MarqueeItem key={`b-${i}`} s={s} index={i + sources.length} />
            ))}
          </div>
        </div>
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[var(--subtxt-bg)] to-transparent pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[var(--subtxt-bg)] to-transparent pointer-events-none" />
      </div>
    </section>
  );
};
